<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Crear Campo</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div v-if="isDataLoaded" class="row justify-content-center">
        <field-form ref="fieldForm" :edit-mode="true" :field="field" @save="saveField"></field-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import FieldForm from './Forms/FieldForm';
import swal from 'sweetalert2';

export default {
  name: 'FieldsEdit',
  components: {
    RouteBreadCrumb,
    FieldForm,
  },

  data() {
    return {
      isDataLoaded: false,
      field: null,
    };
  },

  created() {
    const fieldId = this.$route.params.id;
    this.fetchField(fieldId);
  },

  methods: {
    fetchField(fieldId) {
      let params = {
        include: ['producer', 'city.province'],
      };

      this.$services
        .resource('fields')
        .show(fieldId, params)
        .then((res) => res.data.data)
        .then((field) => {
          this.field = field;
          this.isDataLoaded = true;
        });
    },

    saveField(field) {
      let data = Object.assign(this.field, this.$refs.fieldForm.get());
      this.$services
        .resource('fields')
        .update(this.field.id, data)
        .then(() => {
          swal({
            title: 'Listo!',
            text: 'El campo fue actualizado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'FieldsList' }));
        });
    },
  },
};
</script>
